<template>

    <div class="ES-xcx-info top10">
    <span class="ES-notice right20">建议尺寸：150px * 70px</span>
        <wcbutton 
        :option="{title:'添加广告'}" 
        @finish="(val)=> {
            if(bannerlist.length==limit) {
                $notice({title:'消息提示',message:'添加广告数量不能超过'+limit,type:'warning'});
                return false;
            }else {
                var datainfo={};
                for(var i in bannerinfo) datainfo[i]=bannerinfo[i];
                bannerlist.push(datainfo);
            }
        }"
        />
    </div>
    <div class="TTL-table top30" :ref="objloading">
    <el-table :data="bannerlist" stripe="true" empty-text="" >
        <template v-slot:empty><el-empty description="暂无数据" /></template>
        <el-table-column label="广告图" align="center">
            <template #default="scope">
            <wcupload :value="scope.row.thumb" :option="{size:'middle', phototype:'system'}" class="uploadImg"  
                @finish="(val)=> {
                    scope.row.thumb=val.url;
                    Updatebanner(scope.$index);
                }"
            />
            </template>
        </el-table-column>
        <el-table-column label="名称" align="center">
            <template #default="scope">
            <wcinput :option="{placeholder:'广告名称',type:'input',width:'110px',ischange:true,isinput:true}" 
                class="uploadImg"
                :value="scope.row.name"
                @finish="(val) => {
                    if(val.type=='change') {
                        scope.row.name=val.value;
                        Updatebanner(scope.$index);
                    }
                }"
            />
            </template>
        </el-table-column>
        <el-table-column label="跳转方式" align="center">
            <template #default="scope">
            <wcselect :option="{placeholder:'跳转方式',ischange:true,width:'130px',filterable:true}" 
                :value="scope.row.jumpurl"
                :list="jumptypelist"
                @finish="(val)=> {
                    scope.row.jumpurl=val.value;
                    scope.row.jumpdataid='';
                    scope.row.jumpdataname='';
                    Updatebanner(scope.$index);
                }"
            />
            </template>
        </el-table-column>
        <el-table-column label="跳转数据" align="center">
            <template #default="scope">
                <div class="es-jump" v-if="scope.row.jumpurl > 0" @click="GetJumpData(scope.row,scope.$index)">{{scope.row.jumpdataname}}</div>
            </template>
        </el-table-column>
        <el-table-column label="广告排序" align="center">
            <template #default="scope">
            <wcinput :option="{placeholder:'排序',type:'input',width:'80px',ischange:true,isinput:true}" 
                class="uploadImg"
                :value="scope.row.sort"
                @finish="(val) => {
                    if(val.type=='change') {
                        scope.row.sort=val.value;
                        Updatebanner(scope.$index);
                    }
                }"
            />
            </template>
        </el-table-column>
        <el-table-column label="操作" align="center"> 
            <template #default="scope">
                <wcbutton :option="{title:'删除',type:'del'}" 
                    @finish="(val)=> {
                        var id=scope.row.id;
                        bannerlist.splice(scope.$index,1);
                        DelBaner(id);
                    }"
                />
            </template>
        </el-table-column>
    </el-table>
    </div>

</template>

<script>
import INTERFACE_XCX from '@/Interface/Es/xcx'; //小程序首页显示
export default {
    components:{INTERFACE_XCX},
    props:['type','jumpdatainfo'],
    data() {
        return {
            objloading:'xcxbanner',
            limit:5,
            bannerinfo: {id:'',name:'',sort:0},
            bannerlist: [],
            jumptypelist:[],
            bannerindex:'',
        }
    },

    mounted() {
        this.GetBannerInfo();
    },

    watch: {
        type(val) {
            this.jumptypelist=val;
            console.log(this.jumptypelist);
        },
        jumpdatainfo(val) {
            if(val) {
                val=JSON.parse(val);
                var index=this.bannerindex;
                var bannerinfo=this.bannerlist[index];
                bannerinfo.jumpdataid=val.id;
                bannerinfo.jumpdataname=val.name;
                this.Updatebanner(index);
            }
        }
    },

    methods: {
        
        //获取banner分类信息
        GetBannerInfo() {
            INTERFACE_XCX.GET_BANNER_LIST().then((res) => {
                 if(res.status > 0) return false;
                 this.bannerlist=res.data;
            });
        },

        /** 更新banner信息 **/
        Updatebanner(index) {
            var bannerinfo=this.bannerlist[index];
            var METHOD=bannerinfo.id > 0 ? 'UPDATE_BANNER' : 'ADD_BANNER';
            INTERFACE_XCX[METHOD](bannerinfo).then((res) => {
                 if(res.status > 0) return false;
                 if(METHOD=='ADD_BANNER') bannerinfo.id=res.data.id;
                 this.bannerlist=this.$method.DATA_SORT(this.bannerlist,{sort:'desc'});
                 this.$emit('finish',{data:this.bannerlist});
            });
        },

        /** 删除广告 **/
        DelBaner(id) {
            INTERFACE_XCX.DEL_BANNER({id:id}).then((res) => {
                 if(res.status > 0) return false;
                 this.bannerlist=this.$method.DATA_SORT(this.bannerlist,{sort:'desc'});
                 this.$emit('finish',{data:this.bannerlist});
            });
        },

        /** 获取跳转参数 **/
        GetJumpData(item,index) {
            this.bannerindex=index;
            var type='selectdata';
            var objname='';
            var childtype='';
            if(item.jumpurl==1) {objname='EsGoods';childtype='selectgoods';}
            if(item.jumpurl==2) {objname='EsTutarial';childtype='selecttutarial';}
            if(item.jumpurl==3) {objname='EsMembers';childtype='selectmember';}
            var param={type:type,objname:objname,childtype:childtype};
            this.$emit('finish',{type:type,data:param});

            // this.$parent.JUMPVIEW({name:'EsMembers',param:{childtype:'selectmember',rollbackindex:index,rollbackobjname:'EsXcxIndex'}})
        },

    },
    
}
</script>
<style scoped>
.ES-xcx-info {display: inline-flex;align-items: center;width:100%;justify-content: flex-end;}
.uploadImg {display:inline-flex;justify-content:center;align-items: center;}
.ES-notice {font-size:12px;color:#333333;margin-top:20px;}
::v-deep(.TTL-input .el-input__inner) {text-align: center;}
.es-jump {cursor: pointer;padding:10px;border-radius: 10px;font-size:13px;color:#333333;background-color: #F0F2F5;}
</style>